import { useEffect } from 'react';
import type { AppProps } from 'next/app';
import Head from 'next/head';
import { useRouter } from 'next/router';

import APP_CONFIG from '@/app.config';
import AllProviders from '@/components/all-providers';
import Analytics from '@/utils/common/analytics';

import 'reflect-metadata';
import '@module-federation/nextjs-mf/lib/include-defaults';

import '@/styles/globals.css';
import '../../public/static/fonts.css';

function MyApp({ Component, pageProps }: AppProps): React.ReactElement {
  const router = useRouter();

  useEffect(() => {
    Analytics.trackPageView();
  }, [router]);

  return (
    <>
      <Head>
        <title>{APP_CONFIG.title}</title>
        <meta name='description' content={APP_CONFIG.description} />
      </Head>
      <AllProviders>
        <Component {...pageProps} />
      </AllProviders>
    </>
  );
}
export default MyApp;
